import { render, staticRenderFns } from "./ChangeAddressList.vue?vue&type=template&id=64c2f84c&scoped=true"
import script from "./ChangeAddressList.vue?vue&type=script&lang=js"
export * from "./ChangeAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2f84c",
  null
  
)

export default component.exports